import Ajv, { Options } from "ajv";
import addFormats from "ajv-formats";

import Debug from "debug";
const debug = Debug("ajv:init");

var CLASSES = {
  Date: Date
  // ...
};

export function initializeAJV(options?: Options) {
  const ajv = new Ajv({
    allErrors: true,
    useDefaults: true,
    keywords: ["uniforms"],
    ...options
  });
  ajv.addFormat(
    "meteorId",
    /^[23456789ABCDEFGHJKLMNPQRSTWXYZabcdefghijkmnopqrstuvwxyz]{3,17}$/
  );
  addFormats(ajv, ["date-time", "uri", "email"]);
  // Add the custom keyword to Ajv
  ajv.addKeyword({
    keyword: "instanceof",
    modifying: true,
    schema: false,

    // returns validation function
    compile: function (schema) {
      debug("check agaist classes %o", schema)
      var Class = CLASSES[schema];
      return function (data) {
        debug("check agaist classes %o, convert data %o, class %o", schema, data, !Class)
        if (!Class) return false;
        return new Class(data) instanceof Date;
      };
    }



  });
  ajv.addKeyword({
    keyword: 'validateAndParseDateTime',
    modifying: true,
    compile: (_schema, parentSchema) => (value, obj) => {
      debug("compile %o", { _schema, parentSchema, obj });
      try {
        if (typeof value === 'string' || typeof value === 'object') {
          const dateValue = new Date(value);
          if (!isNaN(dateValue.getTime())) {
            debug("return date obj %o", dateValue);
            obj.parentData[obj.parentDataProperty] = dateValue;
            // Pass validation
            return true;
          }
        }
        return false;
      }
      catch {
        return false;
      }


    },

  });
  return ajv;
}

// returns function to validate your object
export function createSchemaValidator(schema) {
  const ajv = initializeAJV({ removeAdditional: true })
  const validate = ajv.compile(schema);

  return model => {
    validate(model);

    if (validate.errors && validate.errors.length) {
      console.error("validation error:", validate.errors, model);
      return { details: validate.errors };
    }
    return null; // which now has the default values
  };
}